import { render, staticRenderFns } from "./list-item-subject.vue?vue&type=template&id=0a6b0067"
import script from "./list-item-subject.vue?vue&type=script&lang=js"
export * from "./list-item-subject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports